module.exports = function getResource(label, vars = []) {
    const resources = {
        Standard: `${vars[0] ? '' : 'Consultez votre '}commande standard.`,
        Pickup: `${vars[0] ? '' : 'Consultez votre '}panier d’articles « Achetez en ligne, ramassez en magasin »`,
        Sameday: `${vars[0] ? '' : 'Consultez votre '}commande livrée le jour même.`,
        ShipToHome: `${vars[0] ? '' : 'Consultez votre '}panier d’articles à faire livrer`
    };

    return resources[label];
};
